export default "__VITE_ASSET__DKgXIqXB__"